import _ from 'lodash';
import { isAfter, isBefore, isSameDay } from 'date-fns';

import {
  getRequest,
  patchRequest,
  postRequest
} from '../../Common/network-call';
import { SCRIPT_URI_ADDON, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { isJSONParsable } from '../../../util/util-common';

export const SURVEY_LIST = 'SURVEY_LIST';
export const SELECTED_SURVEY = 'SELECTED_SURVEY';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';

export const fetchSurvey = (
  session,
  extra = { groupIds: [] },
  callback = null
) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScriptSupport.fetchSurveyForm.endpoint}`;
  let postBody = _.cloneDeep(
    SCRIPTS.eventifyScriptSupport.fetchSurveyForm.payload
  );
  postBody.appuserid = session.userid;
  postBody.eventid = session.eventid;

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      response => {
        const list = [];
        const sessionSurvey = [];
        _.map(response.response, item => {
          /**
           * Expected settingsjson structure
           *
           * "settingsjson": {
           *   "assignto": {
           *     "group": ["1","2","3"],
           *     "specific": ["1","2","3"]
           *   },
           *   "startdate": "2024-11-14 00:00:00",
           *   "enddate": "2024-12-14 00:00:00",
           *   "limit": 20
           * }
           */

          let itemSettings = item?.settingsjson;
          let itemOpen = true; // Denotes validity
          let itemAllowed = false; // Denotes allowed to access, set false when released

          if (isJSONParsable(itemSettings)) {
            itemSettings = JSON.parse(itemSettings);

            // --- Checking group-wise allowance
            if (!_.isEmpty(itemSettings?.assignto)) {
              const { specific, group } = itemSettings.assignto || {};
              const specificUsers = _.map(specific, ea => Number(ea));
              const specificGroups = _.map(group, ea => Number(ea));

              if (
                (!_.isEmpty(specificUsers) &&
                  _.includes(specificUsers, session?.userid)) ||
                (!_.isEmpty(specificGroups) &&
                  _.intersection(specificGroups, extra?.groupIds).length > 0) ||
                (_.isEmpty(specificUsers) && _.isEmpty(specificGroups))
              ) {
                itemAllowed = true;
              }
            } else {
              itemAllowed = true;
            }

            // --- Checking if falls under validity
            if (itemAllowed) {
              const validityStarts = new Date(itemSettings?.startdate);
              const validityEnds = new Date(itemSettings?.enddate);
              if (isBefore(new Date(), validityStarts)) return;
              itemOpen = !isAfter(new Date(), validityEnds);
            }
          }

          // based on specific user or group
          if (itemAllowed) {
            const pushItem = {
              ...item,
              allowedit: _.toInteger(item?.allowedit),
              eventid: Number(item?.eventid),
              formid: Number(item?.formid),
              displayorder: _.toInteger(item?.displayorder),
              ismandatory: _.toInteger(item?.ismandatory),
              settingsjson: itemSettings,
              usercapacity: _.toInteger(item?.usercapacity),
              isopen: itemOpen // Denotes validity
            };

            if (!_.isEmpty(item?.sessionid)) {
              pushItem.sessionid = Number(item?.sessionid);
              sessionSurvey.push(pushItem);
            } else list.push(pushItem);
          }
        });

        const mandatorySurveyArr = _.filter(
          list,
          survey =>
            survey?.ismandatory && !survey?.surveytaken && survey?.isopen
        );
        const manSurvFirst = !_.isEmpty(mandatorySurveyArr)
          ? mandatorySurveyArr[0]
          : {};

        // --- Ordered list by display order
        const displayOrderList = _.sortBy(list, 'displayorder');
        const payloadObj = {
          resource: displayOrderList,
          count: displayOrderList.length,
          mandatory: manSurvFirst,
          sessionSurvey
        };

        dispatch({
          type: SURVEY_LIST,
          payload: payloadObj
        });
        dispatch(selectCurrentSurvey(null, manSurvFirst));
        callback &&
          callback({
            success: 1,
            ...payloadObj
          });
      },
      error => {
        callback && callback({ success: 0, message: error });
      }
    );
  };
};

export const clearSurveyList = () => {
  return dispatch => {
    dispatch({ type: SURVEY_LIST, payload: {} });
  };
};

export const selectCurrentSurvey = (session = null, value) => {
  if (
    session &&
    !_.isEmpty(value) &&
    value?.surveytaken &&
    value?.allowedit == 1
  ) {
    return dispatch => {
      dispatch(
        fetchSubmittedSurveyResponse(session, Number(value?.formid), res => {
          if (res.success) {
            // dispatch({ type: SELECTED_SURVEY, payload: {} });

            dispatch({
              type: SELECTED_SURVEY,
              payload: processConditionalRender(res)
            });
          }
        })
      );
    };
  } else {
    return dispatch => {
      dispatch({ type: SELECTED_SURVEY, payload: {} });
      if (!_.isEmpty(value))
        dispatch({
          type: SELECTED_SURVEY,
          payload: processConditionalRender()
        });
    };
  }

  function processConditionalRender(res = null) {
    // --- Survey form structure
    let selectedSurvey = value;
    let checkoutForm = !_.isEmpty(res?.data)
      ? isJSONParsable(res.data?.responses)
        ? JSON.parse(res.data?.responses)
        : []
      : !_.isEmpty(selectedSurvey?.formjson) &&
        isJSONParsable(selectedSurvey?.formjson)
      ? JSON.parse(selectedSurvey?.formjson)
      : [];
    let conditionalForm = {};
    let dynamicFormConditionalFields = [];

    // Process
    if (!_.isEmpty(checkoutForm)) {
      _.map(checkoutForm, (formItem, formItemIndex) => {
        let local_formItem = formItem;

        // --- Conditional detecting
        if (formItem?.hasCondition && !_.isEmpty(formItem?.options)) {
          let localConditional = conditionalForm;

          _.map(formItem.options, (optItem, optItemKey) => {
            if (!_.isEmpty(optItem?.displayfields)) {
              if (_.isEmpty(localConditional[formItem.name]))
                localConditional[formItem.name] = {};

              localConditional[formItem.name][optItem.value] = {
                hide: _.split(optItem.displayfields, ',')
              };

              dynamicFormConditionalFields = [
                ...dynamicFormConditionalFields,
                ..._.split(optItem.displayfields, ',')
              ];
              dynamicFormConditionalFields = _.uniq(
                dynamicFormConditionalFields
              );
            }
          });
        }

        // - Conditional check (hide property added for individual form item)
        local_formItem.hideForCondition = false;
        if (_.includes(dynamicFormConditionalFields, local_formItem.name))
          local_formItem.hideForCondition = true;
      });
    }

    return {
      ...selectedSurvey,
      ...(!_.isEmpty(res?.data) ? { submittedresponse: res.data } : {}),
      processedForm: checkoutForm,
      conditionalForm
    };
  }
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const saveSurvey = (session, update = false, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.surveyResponse}`;
  let body = update
    ? _.cloneDeep(values)
    : { resource: [{ ..._.cloneDeep(values) }] };

  if (update) delete body.id;

  return dispatch => {
    if (update) {
      patchRequest(
        `${url}/${values.id}`,
        body,
        session,
        dispatch,
        patchRes => {
          callback({ success: 1, data: patchRes, error: null });
        },
        error => {
          callback({ success: 0, data: null, error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        postRes => {
          callback({ success: 1, data: postRes, error: null });
        },
        error => {
          callback({ success: 0, data: null, error });
        }
      );
    }
  };
};

export const fetchSubmittedSurveyResponse = (
  session,
  surveyFormId,
  callback
) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(formid=${surveyFormId})AND(appuserid=${session.userid}))`
  );
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.surveyResponse}?fields=${FIELDS.surveyResponse.minInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res.resource?.[0], error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
